<template>
    <div class="modal-backdrop fade show modal-dialog-centered d-flex justify-content-center infrontof">
        <div class="d-flex justify-content-center ">
            <div class="spinner-border text-primary">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

    }
</script>

<style lang="css" scoped>
    .infrontof{
        z-index: 3000!important;
    }
</style>
